import { IClassname } from '@/lib/shared/model/classname';

export const PoolShower = ({ className }: IClassname) => {
  return (
    <svg
      width="32"
      className={className}
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8052 8.97121V8.33225C12.8052 6.46817 13.5457 4.68043 14.8638 3.36232C16.1819 2.04421 17.9696 1.30371 19.8337 1.30371C21.6978 1.30371 23.4855 2.04421 24.8037 3.36232C26.1217 4.68043 26.8623 6.46817 26.8623 8.33225V30.6958"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9169 14.0833C17.9169 12.7276 17.3784 11.4275 16.4197 10.4688C15.4612 9.51023 14.161 8.97168 12.8053 8.97168C11.4496 8.97168 10.1494 9.51023 9.19077 10.4688C8.23216 11.4275 7.6936 12.7276 7.6936 14.0833V14.7223C7.6936 14.8918 7.76092 15.0543 7.88075 15.1742C8.00057 15.2939 8.1631 15.3613 8.33256 15.3613H17.278C17.4474 15.3613 17.61 15.2939 17.7299 15.1742C17.8496 15.0543 17.9169 14.8918 17.9169 14.7223V14.0833Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.6935 20.7923C7.51706 20.7923 7.37402 20.6493 7.37402 20.4728C7.37402 20.2963 7.51706 20.1533 7.6935 20.1533"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M7.6936 20.7923C7.87005 20.7923 8.01308 20.6493 8.01308 20.4728C8.01308 20.2963 7.87005 20.1533 7.6936 20.1533"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M6.41567 24.6263C6.23923 24.6263 6.09619 24.4833 6.09619 24.3068C6.09619 24.1303 6.23923 23.9873 6.41567 23.9873"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M6.41553 24.6263C6.59197 24.6263 6.73501 24.4833 6.73501 24.3068C6.73501 24.1303 6.59197 23.9873 6.41553 23.9873"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M5.13759 28.4593C4.96115 28.4593 4.81812 28.3163 4.81812 28.1398C4.81812 27.9633 4.96115 27.8203 5.13759 27.8203"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M5.1377 28.4593C5.31414 28.4593 5.45717 28.3163 5.45717 28.1398C5.45717 27.9633 5.31414 27.8203 5.1377 27.8203"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M12.8053 28.4593C12.6289 28.4593 12.4858 28.3163 12.4858 28.1398C12.4858 27.9633 12.6289 27.8203 12.8053 27.8203"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M12.8052 28.4593C12.9816 28.4593 13.1247 28.3163 13.1247 28.1398C13.1247 27.9633 12.9816 27.8203 12.8052 27.8203"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M20.4728 28.4593C20.2963 28.4593 20.1533 28.3163 20.1533 28.1398C20.1533 27.9633 20.2963 27.8203 20.4728 27.8203"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M20.4727 28.4593C20.6491 28.4593 20.7921 28.3163 20.7921 28.1398C20.7921 27.9633 20.6491 27.8203 20.4727 27.8203"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M12.8053 24.6263C12.6289 24.6263 12.4858 24.4833 12.4858 24.3068C12.4858 24.1303 12.6289 23.9873 12.8053 23.9873"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M12.8054 24.6263C12.9819 24.6263 13.1249 24.4833 13.1249 24.3068C13.1249 24.1303 12.9819 23.9873 12.8054 23.9873"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M19.1947 24.6263C19.0182 24.6263 18.8752 24.4833 18.8752 24.3068C18.8752 24.1303 19.0182 23.9873 19.1947 23.9873"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M19.1948 24.6263C19.3713 24.6263 19.5143 24.4833 19.5143 24.3068C19.5143 24.1303 19.3713 23.9873 19.1948 23.9873"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M12.8053 20.7923C12.6289 20.7923 12.4858 20.6493 12.4858 20.4728C12.4858 20.2963 12.6289 20.1533 12.8053 20.1533"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M12.8054 20.7923C12.9819 20.7923 13.1249 20.6493 13.1249 20.4728C13.1249 20.2963 12.9819 20.1533 12.8054 20.1533"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M17.9169 20.7923C17.7404 20.7923 17.5974 20.6493 17.5974 20.4728C17.5974 20.2963 17.7404 20.1533 17.9169 20.1533"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M17.917 20.7923C18.0935 20.7923 18.2365 20.6493 18.2365 20.4728C18.2365 20.2963 18.0935 20.1533 17.917 20.1533"
        stroke="#22364A"
        strokeWidth="1.33"
      />
    </svg>
  );
};
